import { ButtonGroup } from '@mui/material';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { useIsDirector } from 'shared/permissions/useIsDirector';
import { useIsSupplier } from 'shared/permissions/useIsSupplier';
import { useIsTechnician } from 'shared/permissions/useIsTechnician';
import { useIsTechnicianCoordinator } from 'shared/permissions/useIsTechnicianCoordinator';
import { useIsTenantAdministrator } from 'shared/permissions/IsTenantAdministrator';
import AddEnhancedButton from 'components/ui/buttons/AddEnhancedButton';
import LinkEnhancedButton from 'components/ui/buttons/LinkEnhancedButton';
import TenantPage from 'layouts/TenantPage';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ticketingService } from '../TicketingService';
import { useTicketColumns } from '../tickets';

export const Tickets = () => {
  const translationPrefix = 'pages.tickets';

  const isDisableEdit = useIsDirector() || useIsSupplier();
  const isAdmin = useIsTenantAdministrator();
  const canViewToApprove = isAdmin || useIsTechnician() || useIsTechnicianCoordinator();

  const { t } = useTranslation();
  const datagridRefresh = useRef(null);

  const [numTicketPending, setNumTicketPending] = useState(0);

  useEffect(() => {
    ticketingService.getTechnicianCreated(0, 0).then((res) => {
      setNumTicketPending(res.count);
    });
  }, []);

  const columns = useTicketColumns();

  return (
    <TenantPage
      title={t(`${translationPrefix}.already-approved`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      pageType="tickets"
      menuRight={
        <ButtonGroup>
          <AddEnhancedButton prefix={translationPrefix} to="new" visible={!isDisableEdit} />
          <LinkEnhancedButton
            label={t(`${translationPrefix}.technician-created`)}
            to="technician-created"
            count={numTicketPending}
            visible={canViewToApprove}
          />
          <LinkEnhancedButton label="global.archive" to="archive" />
        </ButtonGroup>
      }>
      <EnhancedDataGrid
        columns={columns}
        service={ticketingService}
        getMethod={ticketingService.getAlreadyApproved}
        warehouseFilterParam="warehouse_code"
        refresh={datagridRefresh}
        disableDelete
      />
    </TenantPage>
  );
};

export default Tickets;
